export default {"src":"/_next/static/media/JP_v2.7781d0c1.svg","height":35,"width":53,"blurWidth":0,"blurHeight":0};